import useRoutesHandler from "@/Hooks/useRouteHandler";
import { handleNetworkError } from "@/utility/networkError.utility";
import { useAuthServiceMutations } from "@repo/api-services/admin";
import { setAuthorizationHeader } from "@repo/api-services/Axios";
import { ILoginSchema } from "../auth.types";
import queryClientGlobal from "@repo/api-services/queryConfig.ts";
import { CACHE_KEYS } from "@repo/api-services/CacheKeys";
import { ROUTES } from "@/constants/appConfig";

export default function useLogin() {
  const { navigate } = useRoutesHandler();
  const { loginMutation, logoutMutation } = useAuthServiceMutations();

  const handleLogin = async (data: ILoginSchema) => {
    try {
      const response = await loginMutation.mutateAsync(data);
      setAuthorizationHeader(response?.token);
      navigate(ROUTES.HOME);
    } catch (err: any) {
      handleNetworkError(err?.response);
      queryClientGlobal?.invalidateQueries({
        queryKey: [...CACHE_KEYS.CAPTCHA],
      });
      return err;
    }
  };

  const handleLogout = () => {
    logoutMutation.mutateAsync().then(() => {
      queryClientGlobal.clear();
      localStorage.clear();
      navigate(ROUTES.LOGIN);
    });
  };

  return {
    mutations: { loginMutation, logoutMutation },
    functions: { handleLogin, handleLogout },
  };
}
